import React, { useEffect, useState } from 'react';
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import BreadCrumbs from '../BreadCrumbs';
import { closeIcon, filterIcon, homeIcon, leftArrowLong, noTestData, searchIcon, vCopyIcon } from "../../../constants/icons";
import { FormControl } from 'olive-react-myoneui';
import BundleItem from '../card/BundleItem';
import MykPagination from '../MykPagination';
import CourseFilter from './CourseFilter';
import { getEnrolledBundles } from '../../../../api/afterLogin/bundles';
import { useSelector } from 'react-redux';
import CourseFilterMobile from './CourseFilterMobile';
import { imageSrc, filterUrl } from "../../../../helpers/url_helper";
import { CourseItemLoader } from '../../Loader';
import NoItems from './NoItems';
import Error403 from '../../../../modules/Error403';
import { checkDisabledSp } from '../../../../helpers/permission_helper';
import { addDays, format } from "date-fns";

const Bundles = ({ className }) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const adminData  = useSelector((state) => state.admin);
  const configData = useSelector((state) => state.config);
  const paths = useSelector((state) => state.user.paths);
  const contentFilterData = useSelector((state) => state.contentFilter);
  const [data, setData] = useState('');
  const [keywords, setKeywords] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [abortController, setAbortController] = useState(null);
  const [enrolledBundles, setEnrolledBundles] = useState([]);

  const [filterSlide, setFilterSlide] = useState();
  const [searchSlide, setSearchSlide] = useState();
  const [searchQuery, setSearchQuery] = useState('');
  const [scrollPosition, setScrollPosition] = useState(0);
  const [showEmptyItemBlock, setShowEmptyItemBlock] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  /* ACCESS CHECK */
  const products  = adminData.products;
  const userSpEnabled = adminData?.user_sp_enabled;
  const [noAccess, setNoAccess] = useState(checkDisabledSp('mykademy', products, userSpEnabled));

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  const handleFilterSlide = () => {
    const body = document.body;

    if (filterSlide) {
      body.classList.remove('switched-filter-on');
      window.scrollTo(0, scrollPosition);
    } else {
      setScrollPosition(window.scrollY);
      body.classList.add('switched-filter-on');
      window.scrollTo(0, 0);
    }

    setFilterSlide(!filterSlide);
  }
  
  const handleCourseSearchSlide = () => {
    const body = document.body;

    if (searchSlide) {
      body.classList.remove('switched-search-on');
      window.scrollTo(0, scrollPosition);
    } else {
      setScrollPosition(window.scrollY);
      body.classList.add('switched-search-on');
      document.querySelector('.myk__stu-searchbar input[aria-label="Search"]').focus();
      window.scrollTo(0, 0);
    }

    setSearchSlide(!searchSlide);
  }

  const handleClearInput = () => {
    setSearchQuery('');
    document.querySelector('input[aria-label="Search"]').focus();
  };

  const bundlePages = [
    { icon: homeIcon, label: "Home", url: "/student-dashboard/" },
    { icon: vCopyIcon, label: "Bundles" }
  ];

  const fetchContents = async (params) => {
    const {selectedFilters, selectedRadio, formatedValidityDate, selectedValidityDays, offset } = contentFilterData;
    const postParams = {};
    //Enrollment Status Filter
    if(selectedFilters?.enrollmentStatus?.length > 0) {
      const enrollmentStatus = selectedFilters.enrollmentStatus;
      postParams.enroll_status = enrollmentStatus;
    }

    //Validity Status Filter
    if(selectedRadio != '') {
      const validity_type = selectedRadio;
      postParams.validity_type = validity_type;

      if(selectedRadio === "validity-lifetime") {
        postParams.validity = "lifetime";
      } else if( selectedRadio === "validity-days") {
        postParams.validity = selectedValidityDays.value;
      } else {
        postParams.validity = formatedValidityDate.split(" ")[0];
      }
    }

    //Course Type Filter
    if(selectedFilters?.courseType?.length > 0) {
      const courseType = selectedFilters.courseType;
      postParams.content_type = courseType;
    }

    //Category Filter
    if(selectedFilters?.category?.length > 0) {
      const category = selectedFilters.category;
      postParams.categories = category;
    }

    params.page_offset = offset;

    try {
      const allEnrolledBundles = await getEnrolledBundles(configData.access_token, params, postParams);
      if (allEnrolledBundles) {
        setIsLoading(false);
        return allEnrolledBundles;
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);      
    }
  };

  const handleKeywords = (e) => {
    setKeywords(e.target.value);
  }
  
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(keywords);
    }, 500);
    if (abortController) {
      abortController.abort();
    }
    const newAbortController = new AbortController();
    setAbortController(newAbortController);
    const signal = newAbortController.signal;
    return () => clearTimeout(handler);
  }, [keywords]);

  useEffect(() => {
    if (abortController) {
      abortController.abort();
    }
    const newAbortController = new AbortController();
    setAbortController(newAbortController);
    const signal = newAbortController.signal;

    if (signal && !signal.aborted) {
      const loadData = async () => {
        const data = await fetchContents({limit: 15, search: keywords});
        setData(data);
        setEnrolledBundles(data.data);
      }
      loadData();
    }
  }, [contentFilterData, debouncedSearch]);

  const bundleData = enrolledBundles && enrolledBundles.map((value) => {
    let totalCourses         = value?.bundle_course_count ? value?.bundle_course_count : 0;
    let totalTrainingCourses = value.bs_training_courses ? JSON.parse(value.bs_training_courses).length : 0;
    let totalEvents          = value.bs_training_events ? JSON.parse(value.bs_training_events).length : 0;
    let totalLectures        = ((totalCourses > 0) ? totalCourses + ` Course${totalCourses > 1 ? 's' : ''} ` : '') + 
                               ((totalTrainingCourses > 0) ? totalTrainingCourses + ` Training Course${totalTrainingCourses > 1 ? 's' : ''} ` : '') + 
                               ((totalEvents > 0) ? totalEvents + ` Event${totalEvents > 1 ? 's' : ''}` : '');
    const isExpired = value?.c_access_validity === '0' ? false : 
                      new Date(value?.bs_end_date) < new Date();
                             
    const deadlineDate = value?.c_access_validity === '0' ? 'Lifetime Validity' : 
                          value?.bs_end_date ? 'Deadline : ' + format(new Date(value?.bs_end_date), 'MMM d, yyyy') : 'Lifetime Validity';         

    return {
      className: isExpired ? 'expired' : '',
      bundleImage: imageSrc('bundle',value?.c_image, paths),
      bundleType: value?.c_bundle_type && value?.c_bundle_type == 0 ? 'Normal' : 'Package',
      bundleTitle: value?.c_title ?? '',
      bundleCoursesCount: totalLectures,
      bundleTotalCount: parseInt(totalCourses) + totalTrainingCourses + totalEvents,
      bundleTypeLearning: "Bundle",
      bundleButtonLabel: "View Bundle",
      bundleTypeLearning: value?.category,
      bundleStartLink: value?.c_slug ? `/student-dashboard/bundles/${value?.c_slug}` : '',
      bundleStatus: value?.enroll_status === 'not-started' ? 'notStarted' : value?.enroll_status !== 'completed' ? 'inProgress' : 'completed',
      bundleDeadline: deadlineDate,
      isExpired: isExpired ? 'expired' : '',
    }
  });

  return (
    <>
    {noAccess ? <Error403 /> : (
    <>
    <BreadCrumbs pages={bundlePages} />
    <div className={`${className || ""} myk__stu-courses-wrapper`}>
      <Row>
        <Col md={{ span:12, order: 0 }} lg={{ span:12, order: 0 }} xl={{ span:9, order: 0 }} className="">
          <div className="myk_stu-page-header">
            <h2>Enrolled Bundles</h2>
            <div className="myk__stu-searchbar">
              <span className="icon">{searchIcon}</span>
              <FormControl placeholder="Search course by keywords" aria-label="Search" onChange={handleKeywords} />
              <span className="icon-go_back" onClick={handleCourseSearchSlide}>{leftArrowLong}</span>
              <span className="icon-clear" onClick={handleClearInput}>{closeIcon}</span>
            </div>
            <div className="myk__stu-search_filter-mobile">
              <div className="myk__stu-search-wrapper">
                <span className="icon" role="button" onClick={handleCourseSearchSlide}>{searchIcon}</span>
              </div>
              <div className="myk__stu-filter-mobile" role="button" onClick={handleFilterSlide}>
                {filterIcon}
              </div>
            </div>
          </div>
          {screenWidth >= 768 && screenWidth < 1200 && (
            <CourseFilterMobile className="mb-4" />
          )}
          {isLoading === false ? (
          <>
          <Row>
            <Col>
              {enrolledBundles && enrolledBundles.length > 0 ? (
              <div className="myk__stu-courses-list">
                {bundleData.map((bundle, index) => (
                  <BundleItem key={index} {...bundle} />
                ))}
              </div>
              ) : (
              <div className="myk__stu-courseslist-empty p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center">
                <NoItems
                  icon={noTestData}
                  title="No bundles found!"
                  description="There aren’t any bundles! Bundles will be listed here."
                />
              </div>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <MykPagination className="mt-4" data={data}/>
            </Col>
          </Row>
          </>
          ) : (
          <Row>
            <Col>
              <CourseItemLoader type="bundle" items={10} />
            </Col>
          </Row>
          )
          }
        </Col>
        {(screenWidth <= 767 || screenWidth >= 1200) && (
        <Col md={{ span:12, order: 0 }} lg={{ span:12, order: 0 }} xl={{ span:3, order: 0 }} className="">
          <CourseFilter onClickFilterSlide={handleFilterSlide}/>
        </Col>
        )}
      </Row>
    </div>
    </>
    )}
    </>
  );
}

export default Bundles;